import {scrollWindowToTarget} from '../../../services/scrollWindowToTarget';

Hop.defineModule('anchor-link', (root) => {
    function scrollToRelevantTarget(e) {
        e.preventDefault();
        const link = e.target.closest('a');
        const target = document.querySelector(link.getAttribute('href'));

        scrollWindowToTarget(target);
    }

    Hop.delegate(root, 'click', '[href^="#"]:not([href="#"])', scrollToRelevantTarget);
});
